import MainLayout from '@/layout/MainLayout.vue'
import HomePage from '@/pages/home/HomePage.vue'
import DocumentSignatureIndex from '@/pages/document-signature/Index.vue'
import DocumentSignatureList from '@/pages/document-signature/DocumentSignatureList.vue'
import DocumentSignatureSingle from '@/pages/document-signature/single/DocumentSignatureSingle.vue' // eslint-disable-line max-len
import DocumentAgreementSingle from '@/pages/document-agreement/single/DocumentAgreementSingle.vue' // eslint-disable-line max-len
import RecentPage from '@/pages/recent/RecentPage.vue'

import OrderList from '@/pages/orders/OrderList.vue'
import OrderSingle from '@/pages/orders/single/Index.vue'
import OrderGeneralInfo from '@/pages/orders/single/tabs/GeneralInfo.vue'
import OrderAccess from '@/pages/orders/single/tabs/Access.vue'
import OrderConnections from '@/pages/orders/single/tabs/Connections.vue'
import OrderHistory from '@/pages/orders/single/tabs/History.vue'
import OrderTasks from '@/pages/orders/single/tabs/Tasks.vue'
import OrderAcknowledgment from '@/pages/orders/single/tabs/Acknowledgment.vue' // eslint-disable-line max-len
import ProtocolList from '@/pages/protocols/ProtocolList.vue'
import ProtocolSingle from '@/pages/protocols/single/Index.vue'
import ProtocolGeneralInfo from '@/pages/protocols/single/tabs/GeneralInfo.vue'
import ProtocolAccess from '@/pages/protocols/single/tabs/Access.vue'
import ProtocolConnections from '@/pages/protocols/single/tabs/Connections.vue'
import ProtocolHistory from '@/pages/protocols/single/tabs/History.vue'
import ProtocolTasks from '@/pages/protocols/single/tabs/Tasks.vue'
import ProtocolAcknowledgment from '@/pages/protocols/single/tabs/Acknowledgment.vue' // eslint-disable-line max-len
import ContractorList from '@/pages/contractor/ContractorList.vue'
import ContractorSingle from '@/pages/contractor/single/ContractorSingle.vue'
import CompanyStructure from '@/pages/company-structure/company-structure/Index.vue' // eslint-disable-line max-len
import UserList from '@/pages/company-structure/users/UserList.vue'
import CorrespondenceList from '@/pages/correspondence/CorrespondenceList.vue'
import CorrespondenceSingle from '@/pages/correspondence/single/CorrespondenceSingle.vue'
import TaskSingle from '@/pages/task/single/TaskSingle.vue'
import UsersBirthdayList from '@/pages/company-structure/user-birthdays/UsersBirthdayList.vue'
import AbsenceIndex from '@/pages/absence/AbsenceIndex.vue'
import AbsenceDocumentIndex from '@/pages/absence/documents/AbsenceDocumentIndex.vue'
import AbsenceTaskIndex from '@/pages/absence/tasks/AbsenceTaskIndex.vue'
import FamiliarizationList from '@/pages/familiarization/FamiliarizationList.vue'

import DocumentPreview from '@/pages/document/single/tabs/Preview.vue'
import DocumentRequisites from '@/pages/document/single/tabs/requisites/Requisites.vue'
import DocumentRoute from '@/pages/document/single/tabs/route/Route.vue'
import DocumentAttachments from '@/pages/document/single/tabs/Attachments.vue'
import DocumentComments from '@/pages/document/single/tabs/Comments.vue'
import DocumentRelation from '@/pages/document/single/tabs/Relation.vue'

import DelegationIndex from '@/pages/delegation/Index.vue'
import DelegationAgreements from '@/pages/delegation/tabs/Agreements.vue'
import DelegationSignatures from '@/pages/delegation/tabs/Signatures.vue'
import DelegationDocumentSingle from '@/pages/delegation/DelegationDocumentSingle.vue'

import documentRoutes from './default/document'
import registrationRoutes from './default/registration'
import reviewRoutes from './default/review'

import SearchIndex from '@/pages/search/Search.vue'
import AttributeSearch from '@/pages/search/tabs/AttributeSearch.vue'
import AttributeSearchForm from '@/pages/search/tabs/AttributeSearchForm.vue'
import FullTextSearch from '@/pages/search/tabs/FullTextSearch.vue'

export default [
  {
    path: '/eds',
    name: 'eds',
    component: MainLayout,
    meta: {
      title: 'Дашборд',
      hide: true,
    },
    redirect: { name: 'home' },
    children: [
      ...documentRoutes,
      ...registrationRoutes,
      ...reviewRoutes,
      {
        path: '/home',
        name: 'home',
        component: HomePage,
        meta: {
          title: 'Дашборд',
        },
      },
      {
        path: '/delegation/:delegationId/document/:docId',
        name: 'delegation-document',
        component: DelegationDocumentSingle,
        meta: { title: 'Документ делегування', tabList: true },
        redirect: { name: 'delegation-document-preview' },
        children: [
          {
            path: 'preview',
            name: 'delegation-document-preview',
            component: DocumentPreview,
          },
          {
            path: 'requisites',
            name: 'delegation-document-requisites',
            component: DocumentRequisites,
          },
          {
            path: 'route',
            name: 'delegation-document-route',
            component: DocumentRoute,
          },
          {
            path: 'attachments',
            name: 'delegation-document-attachments',
            component: DocumentAttachments,
          },
          {
            path: 'relation',
            name: 'delegation-document-relation',
            component: DocumentRelation,
          },
          {
            path: 'comments',
            name: 'delegation-document-comments',
            component: DocumentComments,
          },
        ],
      },
      {
        path: '/delegation/:id',
        name: 'delegation-single',
        component: DelegationIndex,
        meta: { title: 'Делегування', tabList: true },
        children: [
          {
            path: 'agreements',
            name: 'delegation-agreements',
            component: DelegationAgreements,
            meta: { title: 'Погодження', breadcrumbIdx: 2 },
          },
          {
            path: 'signatures',
            name: 'delegation-signatures',
            component: DelegationSignatures,
            meta: { title: 'Підписання', breadcrumbIdx: 2 },
          },
        ],
      },
      {
        path: '/document-signature',
        name: 'document-signature-list',
        component: DocumentSignatureIndex,
        meta: {
          title: 'Підписання',
          resource: 'document-signatures',
        },
        children: [
          {
            path: ':id',
            name: 'document-signature-single',
            component: DocumentSignatureSingle,
            meta: {
              title: 'Документ',
            },
          },
          {
            path: 'notes',
            name: 'document-signature-notes',
            component: DocumentSignatureList,
            meta: {
              title: 'Чернетки',
            },
          },
          {
            path: 'all',
            name: 'document-signature-all',
            component: DocumentSignatureList,
            meta: {
              title: 'Поточні',
            },
          },
          {
            path: 'signed',
            name: 'document-signature-signed',
            component: DocumentSignatureList,
            meta: {
              title: 'Підписані',
            },
          },
          {
            path: 'canceled',
            name: 'document-signature-canceled',
            component: DocumentSignatureList,
            meta: {
              title: 'Анульовані',
            },
          },
        ],
      },

      {
        path: '/recent',
        name: 'recent',
        component: RecentPage,
        meta: {
          title: 'Недавні документи',
        },
      },
      {
        path: '/familiarization',
        name: 'familiarization',
        children: [
          {
            path: '/familiarization-list-done',
            name: 'familiarization-list-done',
            component: FamiliarizationList,
            meta: {
              title: 'Ознайомлені',
            },
          },
          {
            path: '/familiarization-list-me',
            name: 'familiarization-list-me',
            component: FamiliarizationList,
            meta: {
              title: 'Мені на ознайомлення',
            },
          },
        ],
      },
      {
        path: '/orders',
        name: 'orders',
        redirect: { name: 'order-list' },
        meta: {
          title: 'Накази',
          resource: 'orders',
        },
        children: [
          {
            path: '/order-list',
            name: 'order-list',
            component: OrderList,
            meta: {
              title: 'Всі накази',
            },
          },
          {
            path: ':id',
            name: 'single-order',
            component: OrderSingle,
            meta: {
              title: 'Наказ',
              tabList: true,
            },
            redirect: { name: 'order-general-info' },
            children: [
              {
                path: 'general-info',
                name: 'order-general-info',
                component: OrderGeneralInfo,
                meta: {
                  title: 'Основне',
                  breadcrumbIdx: 2,
                },
              },
              {
                path: 'access',
                name: 'order-access',
                component: OrderAccess,
                meta: {
                  title: 'Доступність',
                  breadcrumbIdx: 2,
                },
              },
              {
                path: 'connections',
                name: 'order-connections',
                component: OrderConnections,
                meta: {
                  title: "Зв'язки",
                  breadcrumbIdx: 2,
                },
              },
              {
                path: 'history',
                name: 'order-history',
                component: OrderHistory,
                meta: {
                  title: 'Історія',
                  breadcrumbIdx: 2,
                },
              },
              {
                path: 'tasks',
                name: 'order-tasks',
                component: OrderTasks,
                meta: {
                  title: 'Історія',
                  breadcrumbIdx: 2,
                },
              },
              {
                path: 'acknowledgment',
                name: 'order-acknowledgment',
                component: OrderAcknowledgment,
                meta: {
                  title: 'Ознайомлення',
                  breadcrumbIdx: 2,
                },
              },
            ],
          },
        ],
      },

      {
        path: '/protocols',
        name: 'protocols',
        redirect: { name: 'protocol-list' },
        meta: {
          title: 'Протоколи',
        },
        children: [
          {
            path: '/protocol-list',
            name: 'protocol-list',
            component: ProtocolList,
            meta: {
              title: 'Всі протоколи',
            },
          },
          {
            path: ':id',
            name: 'single-protocol',
            component: ProtocolSingle,
            meta: {
              title: 'Протокол',
              tabList: true,
            },
            redirect: { name: 'protocol-general-info' },
            children: [
              {
                path: 'general-info',
                name: 'protocol-general-info',
                component: ProtocolGeneralInfo,
                meta: {
                  title: 'Основне',
                  breadcrumbIdx: 2,
                },
              },
              {
                path: 'access',
                name: 'protocol-access',
                component: ProtocolAccess,
                meta: {
                  title: 'Доступність',
                  breadcrumbIdx: 2,
                },
              },
              {
                path: 'connections',
                name: 'protocol-connections',
                component: ProtocolConnections,
                meta: {
                  title: "Зв'язки",
                  breadcrumbIdx: 2,
                },
              },
              {
                path: 'history',
                name: 'protocol-history',
                component: ProtocolHistory,
                meta: {
                  title: 'Історія',
                  breadcrumbIdx: 2,
                },
              },
              {
                path: 'tasks',
                name: 'protocol-tasks',
                component: ProtocolTasks,
                meta: {
                  title: 'Історія',
                  breadcrumbIdx: 2,
                },
              },
              {
                path: 'acknowledgment',
                name: 'protocol-acknowledgment',
                component: ProtocolAcknowledgment,
                meta: {
                  title: 'Ознайомлення',
                  breadcrumbIdx: 2,
                },
              },
            ],
          },
        ],
      },
      {
        path: '/contractors',
        name: 'contractors',
        component: ContractorList,
        meta: {
          title: 'Контрагенти',
          resource: 'contractors',
        },
      },
      {
        path: '/contractor/:id',
        name: 'single-contractor',
        component: ContractorSingle,
        meta: {
          title: 'Контрагент',
          tabList: true,
          resource: 'contractors',
        },
      },
      {
        path: '/company-structure',
        name: 'company-structure',
        component: CompanyStructure,
        meta: {
          title: 'Структура компанії',
          resource: 'users',
        },
      },
      {
        path: '/users',
        name: 'users',
        component: UserList,
        meta: {
          title: 'Співробітники',
          resource: 'users',
        },
      },
      {
        path: '/user-birthdays',
        name: 'user-birthdays',
        component: UsersBirthdayList,
        meta: {
          title: 'Дні народження',
        },
      },
      {
        path: '/correspondence',
        name: 'correspondence-list',
        component: CorrespondenceList,
        meta: {
          title: 'Кореспонденція',
          resource: 'correspondences',
        },
      },
      {
        path: 'correspondence/:id',
        name: 'correspondence-single',
        component: CorrespondenceSingle,
        meta: {
          title: 'Кореспонденція',
          tabList: true,
          resource: 'correspondences',
        },
      },
      {
        path: '/absence-user',
        name: 'absence-user',
        component: AbsenceIndex,
        meta: { title: 'Заміщення' },
        children: [
          {
            path: 'absence-document-agreement-me/:absenceId',
            name: 'absence-document-agreement-me-list',
            component: AbsenceDocumentIndex,
            meta: { title: 'На візуванні' },
            children: [
              {
                path: 'absence-document-agreement-single/:id',
                name: 'absence-document-agreement-single',
                component: DocumentAgreementSingle,
                meta: { title: 'Документ', tabList: true },
              },
            ],
          },
          {
            path: 'absence-document-signature-all/:absenceId',
            name: 'absence-document-signature-all-list',
            component: AbsenceDocumentIndex,
            meta: { title: 'На підписання' },
            children: [
              {
                path: 'absence-document-signature-single/:id',
                name: 'absence-document-signature-single',
                component: DocumentSignatureSingle,
                meta: { title: 'Заміщення | Документ', tabList: true },
              },
            ],
          },
          {
            path: 'absence-incoming-tasks/:absenceId',
            name: 'absence-incoming-tasks',
            component: AbsenceTaskIndex,
            meta: { title: 'Вхідні завдання' },
            children: [
              {
                path: 'absence-single-task/:id',
                name: 'absence-single-task',
                component: TaskSingle,
                meta: { title: 'Заміщення | Завдання', tabList: true },
              },
            ],
          },
          {
            path: 'absence-outgoing-tasks/:absenceId',
            name: 'absence-outgoing-tasks',
            component: AbsenceTaskIndex,
            meta: { title: 'Вхідні завдання' },
            children: [
              {
                path: 'absence-single-task/:id',
                name: 'absence-single-task',
                component: TaskSingle,
                meta: { title: 'Заміщення | Завдання', tabList: true },
              },
            ],
          },
        ],
      },
      {
        path: '/eds-search',
        name: 'eds-search',
        component: SearchIndex,
        redirect: { name: 'eds-search-attribute' },
        meta: {
          title: 'Пошук',
        },
        children: [
          {
            path: 'attribute',
            name: 'eds-search-attribute',
            component: AttributeSearch,
            meta: { title: 'Атрибутивний пошук' },
          },
          {
            path: 'attribute/:classKey',
            name: 'eds-search-attribute-class',
            component: AttributeSearchForm,
            meta: { title: 'Атрибутивний пошук' },
          },
          {
            path: 'full-text',
            name: 'eds-search-full-text',
            component: FullTextSearch,
            meta: { title: 'Повнотекстовий пошук' },
          },
        ],
      },
    ],
  },
]
